module.exports = __webpack_public_path__ + "bc43a6725e95548bb7267bd0cc744162.jpg";